import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoaderImg from '../../../assets/images/loader.gif';
import './loader.css';

const Loader = ({ 
  message, 
  isBlocking = false
}) => {
  const { t } = useTranslation();
  const [announceMessage, setAnnounceMessage] = useState('');

  const loaderMessage = message || t('LOADER_DEFAULT_MESSAGE');

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnnounceMessage(loaderMessage);
    }, 100);
    return () => clearTimeout(timer);
  }, [loaderMessage]);

  return (
    <div className="loader-overlay" role="dialog" aria-modal="true" aria-label={loaderMessage}>
      <div className="loader-container">
        <div
          role="alert"
          aria-atomic="true"
          className="loader-text"
        >
          <p>{announceMessage}</p>
        </div>
        <div className="spinner" aria-hidden="true">
          <img src={LoaderImg} className="loader-img" alt="" />
        </div>
      </div>
    </div>
  );
};

const LoaderCompletionAnnouncer = ({ message }) => {
  const { t } = useTranslation();
  const completionMessage = message || t('LOADER_COMPLETION_MESSAGE');
  const [announced, setAnnounced] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnnounced(completionMessage);
    }, 100);
    return () => clearTimeout(timer);
  }, [completionMessage]);

  return (
    <div role="status" aria-live="assertive" aria-atomic="true" className="sr-only">
      {announced}
    </div>
  );
};

export { LoaderCompletionAnnouncer };
export default Loader;